import { Component, input } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

@Component({
  selector: 'ui-modal',
  standalone: true,
  imports: [MatDialogModule, UiLabelTranslatePipe],
  templateUrl: './ui-modal.component.html'
})
export class UiModalComponent {
  readonly title = input('');
  readonly description = input('');
}
